export const DISPLAY_NAVIGATION = 'DISPLAY_NAVIGATION';
export const HIDE_NAVIGATION = 'HIDE_NAVIGATION';
export const SET_LANGUAGE = 'SET_LANGUAGE';


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/navigation/constants.ts